import { render, staticRenderFns } from "./Flame.vue?vue&type=template&id=2577fb3c&"
import script from "./Flame.vue?vue&type=script&lang=js&"
export * from "./Flame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports